/** Default visible columns in left-to-right display order (schema order matches). */
export const PROPERTIES_TABLE_DEFAULT_VISIBLE_KEYS = ['name', 'student_housing', 'actions'];

/** Bump when default columns/order change so persisted prefs reset. */
export const PROPERTIES_TABLE_STORAGE_KEY = 'properties-list-v9';
